import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { LoadingModule } from '@ebw-monorepo/loading';
import { CONFIG_SERVICE_ADAPTER, MapModule } from '@ebw-monorepo/map';
import { MaterialModule } from '@ebw-monorepo/material';
import { NavigationModule } from '@ebw-monorepo/navigation';
import { UserProfileModule } from '@ebw-monorepo/user-profile';
import { ENVIRONMENT_TOKEN } from '@ebw-monorepo/utils';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { MapWrapperComponent } from './components/map-wrapper/map-wrapper.component';
import { SplitPortalComponent } from './components/map-wrapper/split-portal/split-portal.component';
import { NioEmptyPageComponent } from './components/nio-empty-page/nio-empty-page.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { ConfigService } from './services/config.service';
import { NotificationModule } from './shared-modules/notification/notification.module';
//https://v13.material.angular.io/components/ripple/overview
const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 200,
    exitDuration: 0
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    MapWrapperComponent,
    UserMenuComponent,
    SplitPortalComponent,
    NioEmptyPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    LoadingModule,
    I18NTranslateModule,
    NavigationModule,
    MapModule,
    UserProfileModule,
    NotificationModule
  ],
  providers: [
    { provide: DatePipe, useClass: class {} },
    { provide: CONFIG_SERVICE_ADAPTER, useExisting: ConfigService },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
    MatIconRegistry
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
